import Config from 'src/util/config'
import API from 'src/util/api'

export const DeleteExerciseMasterService = id =>
  API.put(`${Config.API_URI}deleteExerciseMaster/${id}`)
export const DeleteExerciseDetailService = id =>
  API.put(`${Config.API_URI}deleteExerciseDetail/${id}`)
export const DeleteExerciseDetailMediaService = (id, params) =>
  API.patch(`${Config.API_URI}deleteExerciseDetailMedia/${id}`, params)
